export default __webpack_public_path__ + "static/media/izabela.f3737353.jpg";